import { render, staticRenderFns } from "./add-or-edit-project-scene.vue?vue&type=template&id=bcb9d4f6&scoped=true&"
import script from "./add-or-edit-project-scene.vue?vue&type=script&lang=js&"
export * from "./add-or-edit-project-scene.vue?vue&type=script&lang=js&"
import style0 from "./add-or-edit-project-scene.vue?vue&type=style&index=0&id=bcb9d4f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb9d4f6",
  null
  
)

export default component.exports